import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { AssetImage } from '../enums/asset-image';

export abstract class AssetImagesProviderService {
  public abstract images(): Map<AssetImage, string>;

  public abstract rootDir(): string;

  public url(image: AssetImage): string {
    const name = this.images().get(image);

    if (isNil(name)) {
      const key = AssetImage[image];

      throw new EntryNotFoundException(
        `The image entry for "${key}" not found.`,
      );
    }

    return `${this.rootDir()}/${name}`;
  }
}
